export default __webpack_public_path__ + "static/ionq-logo-one-color-586a705c908b7095fd51efa0b63d8d62.svg";